import salesBudgetYearImport from './salesBudgetYearImport';

export default salesBudgetYearImport;
